export default __webpack_public_path__ + "static/media/civilization.37b9f22c.jpg";